module.exports = __webpack_public_path__ + "assets/images/pages/job/trainee-graphic-designer-card.png?8b2164bf";